<script>
export default {
    name: 'Click',
    props: ['url'],
    mounted() {
        window.open(this.url);
        this.$router.push({name: 'Home'})
    }
}
</script>